import { type Entity, EntityType, type GenericMap } from "@client/types";
import blockDefinitions from "./block/definitions.json";
import blockStructure from "./block/structure.json";
import columnDefinitions from "./column/definitions.json";
import columnStructure from "./column/structure.json";
import containerDefinitions from "./container/definitions.json";
import containerStructure from "./container/structure.json";

import { getEntityOrientation } from "@client/lib/layout";
import { generateId } from "@client/lib/random";
import { addVersion } from "@client/lib/settings";
import popupDefinitions from "./popup/definitions.json";
import popupStructure from "./popup/structure.json";
import rowDefinitions from "./row/definitions.json";
import rowStructure from "./row/structure.json";
import { getStructureDefaultValue } from "./structure";

const getEntityDefaultSettingsInner = (type: EntityType): GenericMap<any> => {
  switch (type) {
    case EntityType.Popup:
      return getStructureDefaultValue("popup", popupStructure, popupDefinitions);
    case EntityType.Block:
      return getStructureDefaultValue("block", blockStructure, blockDefinitions);
    case EntityType.Row:
      return getStructureDefaultValue("row", rowStructure, rowDefinitions);
    case EntityType.Column:
      return getStructureDefaultValue("column", columnStructure, columnDefinitions);
    case EntityType.Container:
      return getStructureDefaultValue("container", containerStructure, containerDefinitions);
    default:
      throw new Error(`Unsupported entity type: ${type}`);
  }
};

export const getEntityDefaultSettings = (type: EntityType): GenericMap<any> =>
  addVersion(getEntityDefaultSettingsInner(type));

export const createEntity = (
  parentId: string | null,
  type: EntityType,
  dimensionSize: number | null = null,
  isStatic?: boolean
): Entity => {
  const settings = getEntityDefaultSettings(type);
  return {
    parentId,
    type,
    id: generateId(),
    childrenIds: [],
    settings,
    orientation: getEntityOrientation(type),
    dimensionSize,
    isStatic
  };
};
